"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateContainer = void 0;
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const StateContainer = ({
  children
}) => {
  const state = (0, _hooks.useReducerState)({
    currentStep: 0
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.StateProvider, {
    value: state,
    children: children
  });
};
exports.StateContainer = StateContainer;
